const global = window;
const { selfHelp: { runAuthDiagnostics } } = global;
// manages a blob which contains data on all of the diagnostic tests which are ran and
// can be downloaded.
/** Object which contains all the diagnostic data for the page */
export const diagnostics = {
    browserInfo: null,
    fetchManifest: null,
    clientSideDependencyEndpoints: null,
    serviceHealthEndpoints: null,
    loadIFrame: null,
    localStorage: null,
    sessionStorage: null,
    webWorkers: null,
};
/**
 * Hosting service diagnostics will now happen within ClientSideDiagnostics.
 * Removing this from the diagnostics file download.
 */
//if (runAfdDiagnostics) { diagnostics.hostingService = null; }
if (runAuthDiagnostics) {
    diagnostics.authToken = null;
}
/**
 * function which updates the download link for the blob. updated automatically on page
 * load and every time diagnostics are updated on page via manual click
 */
export function downloadBlob() {
    const a = document.createElement("a");
    const diagnosticsJSON = JSON.stringify(diagnostics, null, "\t");
    const blob = new Blob([diagnosticsJSON], { type: "application/json" });
    const blobUrl = URL.createObjectURL(blob);
    const div = document.getElementById("shdid-hidden-iFrame");
    a.download = "diagnostics.json";
    a.href = blobUrl;
    a.classList.add("shd-hide");
    div.appendChild(a);
    a.click();
    a.remove();
}
/**
 * Updates blob object with the given diagnostic data
 *
 * @param {string} key - the name of the value on the blob to be updated
 * @param {DiagnosticStatus} updateVal - the value to be added to the blob
 */
export function updateBlob(key, updateVal) {
    diagnostics[key] = updateVal;
}
/**
 * Resets all blob values back to null so that tests can be ran multiple times w/o refresh
 */
export function resetAllBlobData() {
    Object.keys(diagnostics).forEach((test) => {
        diagnostics[test] = null;
    });
}
/**
 * Sets the blob values to null when individual tests are ran for a second time
 *
 * @param key - the key for the test which is being ran
 */
export function resetPartialBlobData(key) {
    diagnostics[key] = null;
}
//# sourceMappingURL=BlobHelper.js.map